"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var redux_1 = require("redux");

var middleware_1 = require("../middleware"); // if you're using redux-thunk or other middlewares, add them here


var createStoreWithMiddleware = redux_1.compose(middleware_1.default)(redux_1.createStore);

exports.configureStore = function (reducers, initialState) {
  if (initialState === void 0) {
    initialState = {};
  }

  return createStoreWithMiddleware(reducers, initialState);
};